import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_FUTURE_SAP_MARKETING_CONSENT_REQUIRED = createFcmConfig('future_sap_marketing_consent_required', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
